import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import ArgoToolbarHook from "./ArgoToolbarHook";
import CategoryReviewHook from "../qd/categories/CategoryReviewHook";
import GroupReviewHook from "../qd/groups/GroupReviewHook";
import QuestionReviewHook from "../qd/questions/QuestionReviewHook";
import * as TEMPLATE from "../../constants/templateConstants";
import { popCallBack, pushCallBack } from "../../actions/reviewTemplateActions";


const ArgoReviewTemplateHook = (props) => {
    const [didRender, setDidRender] = useState(false);
    const [childComponent, setChildComponent] = useState(true);

    const callbacks = useSelector(state => state.reviewTemplate.callbacks);
    const dispatch = useDispatch();

    const fieldName = "review-back";
    const scrollTo = "ArgoReviewTemplate-height-div";

    useEffect(() => {
        if (callbacks.length === 0) setChildComponent(false);

        dispatch(pushCallBack(props.handleToolbarButtonClickFunction));

        setDidRender(true);

        // Clean up function - not needed in the original class version but good practice in hooks
        return () => {
            // Clean up if needed
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        let page = document.getElementById(scrollTo);
        if (page) {
            page.scrollIntoView({ block: 'end',  behavior: 'smooth' });
        }
    }, [didRender]);


    const onCallback = (event, fieldName, buttonTitle) => {
        //calling last callback function before it is removed
        callbacks[callbacks.length - 1](event, fieldName, buttonTitle);
        dispatch(popCallBack());
    };
    
    return (
        <div id="ArgoReviewTemplate-container-div" style={{height: "100%"}}>
            {!childComponent ?
                <div style={{width: "100%"}}>
                    <ArgoToolbarHook
                        fileName="ArgoReviewTemplate"
                        fieldName={fieldName}
                        buttonTitles={["BACK"]}
                        onClick={onCallback}
                        width={props.width}
                    />
                    <div id={scrollTo} style={{height: "50px"}}></div>
                </div>
                : ""}
            <div style={{height: "100%"}}>
            {
                props.templateType === TEMPLATE.TYPE.CATEGORY ?
                    <CategoryReviewHook templateKey={props.templateKey} templateId={props.templateId} selectedTemplate={props.selectedTemplate} selectedTemplateIsGraph={props.selectedTemplateIsGraph} scrollTo={scrollTo}/>
                :
                props.templateType === TEMPLATE.TYPE.GROUP ?
                    <GroupReviewHook templateKey={props.templateKey}  templateId={props.templateId} selectedTemplate={props.selectedTemplate} selectedTemplateIsGraph={props.selectedTemplateIsGraph} scrollTo={scrollTo}/>
                :
                    <QuestionReviewHook templateKey={props.templateKey} templateId={props.templateId}  selectedTemplate={props.selectedTemplate} selectedTemplateIsGraph={props.selectedTemplateIsGraph} scrollTo={scrollTo}/>
            }
            </div>
        </div>
    );
};

ArgoReviewTemplateHook.defaultProps = {
    width: "100%",
    templateIsGraph: false
};

ArgoReviewTemplateHook.propTypes = {
    templateType: PropTypes.string,
    templateKey: PropTypes.string,
    templateId: PropTypes.number,
    selectedTemplate: PropTypes.object,
    selectedTemplateIsGraph: PropTypes.bool,
    handleToolbarButtonClickFunction: PropTypes.func,
    width: PropTypes.string
};

export default ArgoReviewTemplateHook;